import React, { useState, useEffect } from 'react';

const MultiSelect = ({
  options = [],
  selectedItems = [],
  onSelectionChange,
  placeholder = "Selecione um produto...",
  loading = false,
  disabled = false,
  onFocus,
  onSearch
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const filteredOptions = options;

  const handleSelect = (item) => {
    const isSelected = selectedItems.some(selected => selected.value === item.value);
    
    if (isSelected) {
      const newSelection = selectedItems.filter(selected => selected.value !== item.value);
      onSelectionChange(newSelection);
    } else {
      onSelectionChange([item]);
    }
    
    setSearchTerm('');
  };

  const handleRemove = (itemToRemove) => {
    const newSelection = selectedItems.filter(item => item.value !== itemToRemove.value);
    onSelectionChange(newSelection);
  };

  const handleInputClick = () => {
    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
      
      if (onFocus) {
        onFocus();
      }
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setIsOpen(true);
    
    if (onSearch && value.length >= 2) {
      onSearch(value);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.multi-select-container')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="multi-select-container" style={{ position: 'relative' }}>
      <div style={{ position: 'relative' }}>
        <input
          type="text"
          className="form-control multi-select-input"
          placeholder={placeholder}
          value={searchTerm}
          onChange={handleInputChange}
          onClick={handleInputClick}
          disabled={disabled}
          style={{ paddingRight: '30px', height: '38px', boxSizing: 'border-box' }}
        />
        <div
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            color: '#6c757d'
          }}
        >
          <i className="fas fa-chevron-down"></i>
        </div>

        {isOpen && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              zIndex: 1000,
              backgroundColor: 'white',
              border: '1px solid #ccc',
              borderRadius: '4px',
              maxHeight: '200px',
              overflowY: 'auto',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            {loading ? (
              <div className="p-2 text-center">
                <small>Carregando...</small>
              </div>
            ) : filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => {
                const isSelected = selectedItems.some(selected => selected.value === option.value);
                return (
                  <div
                    key={index}
                    className="p-2 border-bottom"
                    style={{ 
                      cursor: 'pointer',
                      backgroundColor: isSelected ? '#e3f2fd' : 'transparent'
                    }}
                    onClick={() => handleSelect(option)}
                  >
                    <small>{option.label}</small>
                    {isSelected && <i className="fas fa-check ml-2" style={{ color: '#1976d2' }}></i>}
                  </div>
                );
              })
            ) : (
              <div className="p-2 text-center">
                <small>Nenhum produto encontrado</small>
              </div>
            )}
          </div>
        )}
      </div>

      {selectedItems.length > 0 && (
        <div className="mt-2">
          <small><strong>Produtos selecionados ({selectedItems.length}):</strong></small>
          <div className="mt-1">
            {selectedItems.map((item, index) => (
              <div key={index} className="d-flex justify-content-between align-items-center p-1 bg-light border rounded mb-1">
                <small>{item.label}</small>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => handleRemove(item)}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiSelect; 